import React from 'react';
import { useSeason } from '../../contexts/SeasonContext';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Calendar } from 'lucide-react';

export function SeasonSelector() {
    const { currentSeason, setCurrentSeason, availableSeasons, defaultSeason } = useSeason();
    if (!availableSeasons.length) return null;

    const isHistorical = currentSeason !== defaultSeason;

    return (
        <div className="flex items-center gap-2" data-testid="season-selector">
            <Calendar className="w-3.5 h-3.5 text-white/30" />
            <Select value={currentSeason} onValueChange={setCurrentSeason}>
                <SelectTrigger className={`h-8 w-36 text-xs border-white/10 ${isHistorical ? 'bg-amber-500/10 border-amber-500/30 text-amber-400' : 'bg-black/50 text-white/70'}`}>
                    <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-[#0a0a0a] border-white/10 max-h-64">
                    {availableSeasons.map(s => (
                        <SelectItem key={s} value={s} className="text-white hover:bg-white/10 text-xs">
                            {s}{s === defaultSeason ? ' (Current)' : ''}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
            {isHistorical && (
                <span className="text-[10px] text-amber-400 tech-mono">HISTORICAL</span>
            )}
        </div>
    );
}
